<template>
    <div>
        <ion-item lines="full" bold :detail="!!Object.keys(service.breakdown).length" 
            @click="showBreakdown =! showBreakdown">
            <ion-label>{{ service.label }}</ion-label>
            <div slot="end">£{{ service.total }}</div>
        </ion-item>
        <ion-item nav-clear menu-close lines="full" v-if="Object.keys(service.breakdown).length && showBreakdown">
            <ion-list lines="full" style="width:100%">
                <ion-item
                    v-for="(total, serviceName) in service.breakdown"
                    :key="serviceName"
                >
                    <ion-label>{{ products[serviceName] }}</ion-label>
                    <div slot="end">£{{ total }}</div>
                </ion-item>
            </ion-list>
        </ion-item>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showBreakdown: false
        }
    },
    props: {
        service: {
            type: Object,
            required: true
        },
        products: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped></style>
